import { StaticImage } from 'gatsby-plugin-image';
import type { FC } from 'react';
import { SwiperSlide } from 'swiper/react';

import { AddOnsTemplate } from '@/components/add-ons/template';
import { GalleriesItem } from '@/components/galleries/item';
import { GalleriesList } from '@/components/galleries/list';
import { ComponentsHead } from '@/components/head';
import { LinkWithTitle } from '@/components/links';
import { AnchorWithTitle } from '@/components/links/anchor';

export const BOTTLE_GIRL_BOY_TITLE = 'Bottle Girl/Boy';

export const Head = () => {
  return (
    <ComponentsHead
      title="VIP Bottle Service on Tampa Charters | TBBA Add-On"
      description="Book a Bottle Girl or Bottle Boy for your next charter. Experience VIP-level hospitality, polished vibes, and five-star beach club energy on the water."
      keywords="Bottle Service, VIP, Hospitality, Add-On"
    />
  );
};

const AddOnsBottleGirlBoy: FC = () => {
  return (
    <AddOnsTemplate
      title="VIP Bottle Service Add-On: Bottle Girl or Bottle
            Boy on Board"
      subtitle="Bottle Girl/Boy Add-On – VIP Service On the Water"
    >
      <GalleriesList>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${BOTTLE_GIRL_BOY_TITLE} header`}
              src="../../images/add-ons/bottle-girl-boy/VIPBottle1.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${BOTTLE_GIRL_BOY_TITLE} slide 1`}
              src="../../images/add-ons/bottle-girl-boy/VIPBottle2.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${BOTTLE_GIRL_BOY_TITLE} slide 2`}
              src="../../images/add-ons/bottle-girl-boy/VIPBottle3.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
      </GalleriesList>
      <p>
        Want to take your Tampa Bay charter to the next
        level? Our Bottle Girl/Boy Add-On is the ultimate
        way to bring that upscale, VIP energy to your
        private boat party. Whether you’re celebrating a
        birthday, hosting a bachelorette bash, or just want
        to add extra flair to your cruise, this service
        levels up your experience from the moment you step
        on board.
      </p>
      <p>
        When you book this add-on, we’ll assign one of our
        polished and professional hosts to your charter.
        Each Bottle Girl or Bottle Boy is there to make your
        party seamless — from popping champagne to passing
        drinks and helping with guest comfort, they’ve got
        it covered. It’s like having your own personal vibe
        curator, right on deck.
      </p>
      <p>
        This service pairs perfectly with other luxury
        enhancements like our{' '}
        <LinkWithTitle to="/faqs/">
          Custom DJ Setlist Add-On
        </LinkWithTitle>
        , where your host and DJ can sync energy for an
        unforgettable flow. Want to document it all? Add a
        Professional photographer to your booking and
        capture every cheers, laugh, and perfect sunset
        pose.
      </p>
      <p>
        You can bundle this experience into any of our{' '}
        <LinkWithTitle to="/services/4-hour-private-party-boat-charter/">
          4-hour
        </LinkWithTitle>
        ,{' '}
        <LinkWithTitle to="/services/6-hour-private-party-boat-charter/">
          6-hour
        </LinkWithTitle>
        , or{' '}
        <LinkWithTitle to="/services/8-hour-private-party-boat-charter/">
          8-hour private party charters
        </LinkWithTitle>
        . It’s especially popular for bachelorette parties,
        birthday celebrations, and full-on party-boat
        charters where that little extra luxury makes a huge
        difference.
      </p>
      <p>
        Bottle service on a boat isn’t just about the drinks
        — it’s about the vibe. It’s about creating that
        “this is the best day ever” feeling. And if you’re
        planning to cruise by{' '}
        <AnchorWithTitle href="https://sparkmanwharf.com/">
          Sparkman Wharf
        </AnchorWithTitle>
        , Downtown Tampa, or Harbour Island, there’s no
        better way to roll up in style.
      </p>
      <p>
        Looking for a complete VIP package? Pair this add-on
        with our curated{' '}
        <LinkWithTitle to="/destinations/">
          charter routes
        </LinkWithTitle>
        , DJ services, and more — and let Tampa Bay Boating
        Adventures build the best day on the water you’ve
        ever had.
      </p>
    </AddOnsTemplate>
  );
};

export default AddOnsBottleGirlBoy;
